import { Signature } from './signature';
import { Person } from './person';

export class View_signature extends Signature {
	horse_show_name: string;
	horse_show_start_date: Date;
	horse_show_end_date: Date;
	horse_show_location: string;
	waiver_text: string;
	username: string;
	horse_name: string;
	owner_name: string;
	trainer_name: string;
	riders: Person[];

	constructor(values: Object = {}) {
		super(values);
		Object.assign(this, values);
	}

}